import { useEffect, useRef } from "react"
import { useConfigFlag } from "@cloudbreakus/featurebang-react"
import { dataService } from "utils/dataService"
import { logger } from "utils/logger"
import MEDIA_SERVER_TYPES from "constants/mediaServerTypes"

const isAnyMeeting = (call) => call?.interaction?.mediaServer === MEDIA_SERVER_TYPES.ANYMEETING

const isAnyMeetingClientTarget = (target) => target === "iframe" || target === "popup"

export const useAnyMeetingTargetOnRing = ({ ringingCall, answeredCall, setAnyMeetingClientTarget }) => {
  const fetchedInteractionIdRef = useRef(null)
  const anyMeetingIframeFlag = useConfigFlag("ui.useAnyMeetingIframe", false)
  const fallbackTarget = anyMeetingIframeFlag ? "iframe" : "popup"
  const call = ringingCall || answeredCall
  const interactionId = call?.interaction?.id

  useEffect(() => {
    if (!interactionId) return
    if (!isAnyMeeting(call) || fetchedInteractionIdRef.current === interactionId) return

    fetchedInteractionIdRef.current = interactionId
    dataService.Interactions.AnyMeetingConfiguration.get({ interactionId })
      .then(({ data }) =>
        setAnyMeetingClientTarget(
          isAnyMeetingClientTarget(data?.anyMeetingClientTarget) ? data.anyMeetingClientTarget : fallbackTarget
        )
      )
      .catch((err) => {
        logger.error("Failed to fetch AnyMeeting configuration, falling back to feature flag", err)
        setAnyMeetingClientTarget(fallbackTarget)
      })
  }, [interactionId, call, setAnyMeetingClientTarget, fallbackTarget])
}
